// @ts-nocheck

export const ORGANISATION_ADMIN_ALLOWLIST = ['jakob@penly.dk', 'asbjoern@penly.dk'];

export function hasOrganisationAdminAccess({ tokenParsed, user } = {}) {
    const email = (tokenParsed?.email || user?.email || '').trim().toLowerCase();
    const realmRoles = tokenParsed?.realm_access?.roles || [];
    const hasClaim = tokenParsed?.['teal:admin'] === true || realmRoles.includes('teal:admin');

    return hasClaim || ORGANISATION_ADMIN_ALLOWLIST.includes(email);
}

export default hasOrganisationAdminAccess;
